import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointMobile,
  BreakPointTablet,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  dialog: {
    gap: theme.spacing.space24,
    [BreakPointMobile]: {
      gap: 0,
    },
  },
  header: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
    padding: `0px ${theme.spacing.space48}px`,
    [BreakPointMobile]: {
      padding: `${theme.spacing.space24}px ${theme.spacing.space16}px`,
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
    width: "-webkit-fill-available",
    padding: `0px ${theme.spacing.space48}px`,
    [BreakPointMobile]: {
      padding: `0px ${theme.spacing.space8}px ${theme.spacing.space4}px`,
    },
  },
  item: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
    alignItems: "start",
  },
  platforms: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: theme.spacing.space16,
    width: "100%",
    [BreakPointMobile]: {
      gap: theme.spacing.space8,
    },
  },
  platformCard: {
    minWidth: 0,
    boxSizing: "border-box",
    borderRadius: 6,
    background: "linear-gradient(96deg, #000 2.35%, #262626 98.12%)",
    padding: theme.spacing.space8,
    display: "flex",
    gap: theme.spacing.space6,
    alignItems: "center",
    cursor: "pointer",
    [BreakPointMobile]: {
      minHeight: 64,
    },
  },
  logoIcon: {
    height: 30,
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    minWidth: 0,
  },
  selected: {
    outline: `2px solid ${theme.colors.Border4}`,
    outlineOffset: 2,
  },
  root: {
    paddingLeft: 0,
    paddingRight: 0,
    '& [class*="actions"]': {
      padding: `0px ${theme.spacing.space48}px`,
      [BreakPointMobile]: {
        padding: `${theme.spacing.space24}px ${theme.spacing.space16}px`,
      },
    },
  },
  hideSelect: {
    cursor: "default",
  },
  cardContentTitle: {
    [BreakPointMobile]: {
      fontSize: "9px !important",
    },
    [BreakPointTablet]: {
      fontSize: "9px !important",
    },
  },
  downloadSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    boxSizing: "border-box",
    borderRadius: 14,
    padding: `0px ${theme.spacing.space48}px`,
    "& > div": {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: theme.spacing.space4,
      zIndex: 1,
      "& > img": {
        display: "block",
        width: 200,
        height: "auto",
      },
    },
    "& > img": {
      display: "block",
      width: 236,
      height: "auto",
      flexShrink: 0,
    },
    [BreakPointMobile]: {
      borderRadius: 10,
      padding: `0px ${theme.spacing.space16}px`,
      "& > div": {
        minWidth: 0,
        flex: "1 1 52%",
      },
      "& > div > img": {
        width: "100%",
        maxWidth: 132,
      },
      "& > img": {
        width: "44%",
        maxWidth: 150,
        minWidth: 0,
      },
    },
  },
}));
